import { render, staticRenderFns } from "./StartBonusClient.vue?vue&type=template&id=50837590&scoped=true&"
import script from "./StartBonusClient.vue?vue&type=script&lang=js&"
export * from "./StartBonusClient.vue?vue&type=script&lang=js&"
import style0 from "./StartBonusClient.vue?vue&type=style&index=0&id=50837590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50837590",
  null
  
)

export default component.exports